import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AuthorizationPartialState, loadPermissions } from '../state';
import * as authorizationQuery from '../state/authorization.selectors';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { NiloPermissions } from '../constants';

@Injectable()
export class AuthorizationFacade {
  isLoading$: Observable<boolean> = this.store.pipe(select(authorizationQuery.getIsLoading));
  permissions$: Observable<string[]> = this.store.pipe(select(authorizationQuery.getPermissions));
  isPermissionsLoaded$: Observable<boolean> = this.store.pipe(
    select(authorizationQuery.getIsPermissionsLoaded),
  );

  constructor(private store: Store<AuthorizationPartialState>) {}

  loadPermissions() {
    this.isPermissionsLoaded$
      .pipe(
        take(1),
        filter((isPermissionLoaded) => !isPermissionLoaded),
      )
      .subscribe(() => {
        this.store.dispatch(loadPermissions());
      });
  }

  /**
   * FIXME: give this a better name and slowly refactor all usages of the method below to this one
   * it's called v2 because i couldn't think of a better name and also didn't have the time.
   * The main change is that you can supply multiple permissions and it will return a tuple with
   * the given permissions in order instead of the logical and that the original method returned
   *
   * There should eventually also be a better interface for this using an object instead of a tuple,
   * but as mentioned above, I didn't have time.
   * @param permissionsToCheck
   */
  hasPermissionsV2$(permissionsToCheck: NiloPermissions[]): Observable<boolean[]> {
    return combineLatest([this.permissions$, this.isPermissionsLoaded$]).pipe(
      filter(([, isPermissionsLoaded]) => isPermissionsLoaded),
      map(([userPermissions]) =>
        permissionsToCheck.map((permission) =>
          userPermissions.includes(NiloPermissions[permission]),
        ),
      ),
    );
  }

  /**
   * @param permissionsToCheck
   */
  hasPermissions$(permissionsToCheck: NiloPermissions[]): Observable<boolean> {
    return combineLatest([this.permissions$, this.isPermissionsLoaded$]).pipe(
      filter(([, isPermissionsLoaded]) => isPermissionsLoaded),
      map(([userPermissions]) =>
        permissionsToCheck.some((permissions) =>
          userPermissions?.includes(NiloPermissions[permissions]),
        ),
      ),
    );
  }
}
